import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage, type Messaging } from 'firebase/messaging';

// TODO: Replace these values with your actual Firebase project config
// Get them from: Firebase Console → Project Settings → General → Your apps → Web app → Config
const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY            ?? '__FIREBASE_API_KEY__',
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN        ?? '__FIREBASE_AUTH_DOMAIN__',
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID         ?? '__FIREBASE_PROJECT_ID__',
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET     ?? '__FIREBASE_STORAGE_BUCKET__',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '__FIREBASE_MESSAGING_SENDER_ID__',
  appId:             import.meta.env.VITE_FIREBASE_APP_ID             ?? '__FIREBASE_APP_ID__',
};

// VAPID key — get from: Firebase Console → Project Settings → Cloud Messaging → Web Push certificates → Key pair
const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY ?? '__FIREBASE_VAPID_KEY__';

const isConfigured = !firebaseConfig.apiKey.startsWith('__');

let messaging: Messaging | null = null;

if (isConfigured) {
  const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
  messaging = getMessaging(app);
}

export { messaging, getToken, onMessage, VAPID_KEY, isConfigured };
